var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{on:{"click":_vm.getPort}},[_vm._v("获取串口")]),_c('div',{attrs:{"id":"name"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }